
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources03Off as ObiSources03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-03-off.js';
 
 
 

 
 export const ObiSources03Off = createComponent({
   react: React,
   tagName: 'obi-sources-03-off',
   elementClass: ObiSources03OffElement,
   events: {
     
   }
  });
 
 